import router from '@/modules/designKit/router'

export default {
  router,
}
